module.exports = "/packs/media/images/Education-000b0f9e2e65bf45e50b2d8ff5b2c2b9.png";